import { lazy } from 'react';
import urlPath from 'src/constants/urlPath';
import MainLayout from 'src/layouts/MainLayout';
import type { RouteGroup } from '@martech-solution/utils/types';

const ReportAccount = lazy(() => import('src/pages/Setting/ReportAccount'));

export const settingRoutes: RouteGroup = [
  {
    path: urlPath.reportAccount.location,
    Layout: MainLayout,
    Component: ReportAccount,
    checkPath: urlPath.reportAccount.location
  }
];
